import { InvoiceDocumentType } from '../enums/invoiceDocumentType'

export const isDocumentTypeInvoice = (documentType: InvoiceDocumentType): boolean =>
  documentType.toLowerCase() === InvoiceDocumentType.Invoice
